import { createWorker } from 'tesseract.js';
import { getOpenAIInstance } from '../openai';

export async function extractTextFromImage(imageFile: File): Promise<string> {
  const worker = await createWorker();
  await worker.loadLanguage('eng');
  await worker.initialize('eng');

  const {
    data: { text },
  } = await worker.recognize(imageFile);
  await worker.terminate();

  return text;
}

export async function categorizeDocument(text: string) {
  const openai = await getOpenAIInstance();

  const completion = await openai.chat.completions.create({
    messages: [
      {
        role: 'system',
        content:
          'You are an expert at categorizing business documents. Analyze the text and determine the document type (invoice, receipt, contract, etc) and extract key information.',
      },
      {
        role: 'user',
        content: `Please analyze this document text and provide the category and key information: ${text}`,
      },
    ],
    model: 'gpt-4-turbo-preview',
  });

  return completion.choices[0].message.content;
}

export async function extractInvoiceData(text: string) {
  const openai = await getOpenAIInstance();

  const completion = await openai.chat.completions.create({
    messages: [
      {
        role: 'system',
        content:
          'Extract key invoice information like invoice number, date, amount, vendor, line items etc. Return as structured JSON.',
      },
      {
        role: 'user',
        content: `Extract invoice data from this text: ${text}`,
      },
    ],
    model: 'gpt-4-turbo-preview',
    response_format: { type: 'json_object' },
  });

  return JSON.parse(completion.choices[0].message.content);
}
